import Vue from "vue";
import Vuex from "vuex";

// general
import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

// modules
import vendor from './modules/vendor'
import registration from "./modules/registration"
import verifikasi from "./modules/verifikasi"
import lelang from "./modules/lelang"

Vue.use(Vuex);

const store = new Vuex.Store({
  strict   : true,
  state    : state,
  getters  : getters,
  mutations: mutations,
  actions  : actions,
  modules  : {
    ven: vendor,
    reg: registration,
    verif: verifikasi,
    lelang: lelang,
  }
});

export default store;
